var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "newExamFace" }, [
    _c("div", { staticClass: "faceBack" }),
    _c("div", { staticClass: "faceDataDlo" }, [
      _c("div", { staticClass: "titleDialog" }),
      _c("div", { staticClass: "faceDiv" }, [
        _c("div", { staticClass: "faceData" }, [
          _c("div", { staticClass: "leftTop" }),
          _c("div", { staticClass: "rightTop" }),
          _c("div", { staticClass: "leftButton" }),
          _c("div", { staticClass: "rightButton" }),
          _c("i", { staticClass: "faceDataLine" }),
          _vm.isFaceVideo
            ? _c("video", {
                attrs: {
                  autoplay: "",
                  playsinline: "",
                  id: "video",
                  width: "100%",
                  height: "200",
                },
              })
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }